import { useContext, useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { GET_INSTALLER_QUERY } from 'Queries/Queries';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import {
  DEB_CURRENT_TEST_SUITE,
  shouldFillDebTestData,
} from 'components/DEBForm/Utils/DebTestSetup';
import { applyFachinteressentMock } from 'components/CardCollectionMyData/MyDataTestSetup';

export const useCurrentInstaller = ({ skip = false } = {}) => {
  const { setShowError } = useContext(ErrorHandlingContext);
  const { data, loading, error, refetch } = useQuery(GET_INSTALLER_QUERY, {
    skip,
  });

  const installer = useMemo(() => {
    const baseInstaller = shouldFillDebTestData
      ? DEB_CURRENT_TEST_SUITE.installerData
      : data?.getInstaller ?? null;

    return applyFachinteressentMock(baseInstaller);
  }, [data]);

  useEffect(() => {
    if (error) {
      console.error('useCurrentInstaller error:', error);
      setShowError((prev) => !prev && true); // Prevent multiple triggers
    }
  }, [error, setShowError]);

  return { installer, isLoading: loading, refetchInstaller: refetch };
};
